export const canUserAccessModule = (user, moduleKey, legacyAllowed) => {
    if (moduleKey === 'ventas' && user?.salesSupplierEditAccess === true && user.isActive !== false && !user.isDeleted) return true;
    const override = user?.moduleAccessOverride;
    const modules = Array.isArray(override) && override.length > 0 ? override : user?.effectiveModules;
    return Array.isArray(modules) ? modules.includes(moduleKey) : Boolean(legacyAllowed);
};

// Support needs an explicit module grant. A global Support role is not enough.
export const canAccessMachineInspections = (user) => {
    const role = user?.role?.uid || user?.role;
    if (!['admin', 'superAdmin', 'technician', 'operator', 'support'].includes(role)) return false;
    return canUserAccessModule(user, 'machine_inspections', role !== 'support');
};

export const canAccessCoffeeRegistration = (user) => {
    if (Array.isArray(user?.moduleAccessOverride) && user.moduleAccessOverride.includes('coffee_registration')) return true;
    const role = user?.role?.uid || user?.role;
    return ['operator', 'support', 'admin', 'superAdmin'].includes(role) && canUserAccessModule(user, 'coffee_registration', true);
};
export const canAccessCoffeeStatistics = (user) => {
    const role = user?.role?.uid || user?.role;
    return ['support', 'admin', 'superAdmin'].includes(role) && canUserAccessModule(user, 'coffee_statistics', true);
};

// Platform denial takes precedence over custom module grants.
const normalize = (value) => typeof value === "string"
  ? value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase() : "";
const OPERATOR_NAMES = new Set(["operator", "operators", "operador", "operadores"]);
export const isOperatorIdentity = (user = {}) => {
  const role = user.role || {};
  if ([role.uid, role.title, role.name, typeof role === "string" ? role : null].some(value => OPERATOR_NAMES.has(normalize(value)))) return true;
  const teams = [user.team?.name, user.team?.title, user.teamName, user.teamTitle,
    typeof user.team === "string" ? user.team : null, user.teamLabel, user.teamId?.name, user.teamId?.title,
    ...(Array.isArray(user.teams) ? user.teams.flatMap(team => [team?.name, team?.title, typeof team === "string" ? team : null]) : [])];
  return teams.some(value => OPERATOR_NAMES.has(normalize(value)));
};

export const canUserAccessMachinePlatforms = (user) => !isOperatorIdentity(user);
